import CreateAccountForm from './CreateAccountForm';
import './CreateAccountForm.scss';

export default CreateAccountForm;
